import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import Measure from 'react-measure';
import PopoutButton from 'containers/PopoutButton/PopoutButtonContainer';
import classes from './CallPresentation.module.scss';

class CallPresentation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopoutButtonVisible: true,
      mouseHover: false
    };
  }

  onMouseEnter = () => {
    this.setState({
      isPopoutButtonVisible: true,
      mouseHover: true
    });
  };

  onMouseLeave = () => {
    this.setState({
      isPopoutButtonVisible: false,
      mouseHover: false
    });
  };

  onButtonTimeout = () => {
    if (!this.state.mouseHover) {
      this.setState({ isPopoutButtonVisible: false });
    }
  };

  unhidePopout = () => {
    this.setState({ isPopoutButtonVisible: true });
  };

  render() {
    const {
      presentationElementId,
      isMinimized,
      popoutPresentation,
      presentationWidth,
      presentationAvailable,
      presentationContainerWidth,
      inlinePresentation,
      onResizeVideo,
      updateVideoRatio,
    } = this.props;
    // always set the width on the presentation rather than the call video
    if (!inlinePresentation) return null;

    return (
      <div
        className={classes.videoContainer}
        style={!isMinimized ? { width: presentationContainerWidth } : { display: 'none' }}
      >
        <Measure
          bounds
          onResize={contentRect =>
            onResizeVideo(presentationElementId, contentRect.bounds)}
        >
          {({ measureRef }) =>
            <video
              ref={measureRef}
              className={classes.video}
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
              id={presentationElementId}
              onLoadedData={() => {
                if (!popoutPresentation) {
                  updateVideoRatio(presentationElementId);
                }
              }}
              style={!isMinimized ? { width: presentationWidth } : null}
            />
          }
        </Measure>
        {presentationAvailable && <PopoutButton
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          onButtonTimeout={this.onButtonTimeout}
          unhidePopout={this.unhidePopout}
          isVisible={this.state.isPopoutButtonVisible}
        />}
      </div>
    );
  }
}

CallPresentation.propTypes = {
  isMinimized: PT.bool.isRequired,
  presentationElementId: PT.string.isRequired,
  popoutPresentation: PT.bool,
  inlinePresentation: PT.bool,
  updateVideoRatio: PT.func,
  onResizeVideo: PT.func,
  presentationWidth: PT.number,
  presentationContainerWidth: PT.number,
  presentationAvailable: PT.bool
};

export default CallPresentation;
